(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ReApplyReDashboardMigrate', ReApplyReDashboardMigrate);

    ReApplyReDashboardMigrate.$inject = ['$resource'];

    function ReApplyReDashboardMigrate ($resource) {
        var resourceUrl =  'api/re-apply-dashboards/migrate-data';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
